import { parseContent } from 'client/data/cms/content';

export function getAuthorMetadata(author) {
  if (!author) {
    return {};
  }

  return {
    avatar: author.metadata('photoPath').value('/img/about/editorial-photos/edmunds.jpg'),
    name: author.metadata('authorName').value(),
    link: author.metadata('authorLink').value(),
    title: author.metadata('authorTitle').value(),
    aboutAuthor: author.metadata('aboutAuthor').value(),
  };
}

export function transformAllAuthorsContent(allAuthors) {
  return {
    author: parseContent(allAuthors?.author),
    coAuthor: parseContent(allAuthors?.coAuthor),
    editor: parseContent(allAuthors?.editor),
  };
}
